import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgModel  } from '@angular/forms';

@Directive({
  selector: '[appTrimText]',
  providers: [NgModel]
})
export class TrimTextDirective {
  constructor(private ngModel: NgModel, private el: ElementRef) {}

  @HostListener('blur', ['$event']) onBlur(event) {
    const value = this.ngModel.model;
    if (value && typeof value === 'string') {
      // Replace more than 2 white spaces by one
      const aux = value.trim().replace(/\s{2,}/g, ' ');
      this.ngModel.update.emit(aux);
    }

    const nativeVal = this.el.nativeElement.value;
    if (nativeVal && typeof nativeVal === 'string' ) {
      // Replace more than 2 white spaces by one
      const nativeAux = nativeVal.trim().replace(/\s{2,}/g, ' ');
      this.el.nativeElement.value = nativeAux;
    }
  }
}
